import s from "./Camp.module.scss";
import PropTypes from "prop-types";

const Camp = ({ 
        url, 
        size = "medium", 
        image = "", 
        alt, 
        title, 
        description, 
        backgroundColor 
    }) => {

    // class CSS basée sur la taille
    const sizeClass = size ? s[size] : s.medium;

    return (
        <a className={s.aCards} href={`${url}`} target="_blank">
            <div className={`${s.card} ${sizeClass}`} style={{ '--description-bg': backgroundColor }}>
                <img src={image} alt={alt} className={s.image} />
                <div className={s.description} style={{backgroundColor: backgroundColor}}>
                    <div>
                        <h3>{title}</h3>
                        <p>{description}</p>
                    </div>
                    <div className={s.arrowContainer}>
                        <div className={s.arrow}>
                            <img src="/assets/arrow.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </a>
    )
}

// Types de props valides : 
Camp.propTypes = {
    url: PropTypes.string,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    image: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
}

export default Camp;